import { Box, makeUclComponent } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import Currency from 'components/currency';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { primitive } from 'styles/constants';

export {
  TransactionDate,
  TransactionDateAndTime,
  TransactionTime,
} from '../loyalty-history/loyalty-history.styled';

export const StyledCurrency = makeUclComponent(Currency).withConfig({
  isBold: false,
});

export const PurchaseAmount = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'flex-end',
});

export const Rewards = Box.withConfig({
  _text: {
    fontWeight: primitive.$fontWeightHeavy,
  },
  flex: 1,
  paddingX: {
    md: '$10',
    base: '$1',
  },
});

export const StyledPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$4',
});

export const PointsText = withTypography({ fontSize: 'md', bold: true, ml: '$1' });

export const IconWrapper = Box.withConfig<{ $pointsEarned: boolean }>({
  flexDirection: 'row',
  alignItems: 'center',
});

export const PointsLineWrapper = Box.withConfig({
  flexDirection: 'column',
  width: 'full',
});

export const PointsDescription = withTypography({
  fontSize: 'sm',
  style: { fontWeight: 'normal', minWidth: 128 },
});
